import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Seller, SellersService } from 'src/app/core/sellers.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-sellers-confirm-otp-dialog',
  templateUrl: './sellers-confirm-otp-dialog.component.html',
  styleUrls: ['./sellers-confirm-otp-dialog.component.scss'],
})
export class SellersConfirmOtpDialogComponent {
  seller?: Seller;
  confirm_otp_form_group = this.form_service.sellers_confirm_otp_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_confirming_otp_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<SellersConfirmOtpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private sellers_service: SellersService,
    private form_service: FormService,
  ) {
    this.seller = data.seller;
  }

  ngOnInit(): void {
    this.confirm_otp_form_group
      .get(this.form_service.confirm_reason_label)
      ?.setValue(this.seller?.confirm_reason || '');
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.confirm_otp_form_group);
  }

  onSetNoteClick(): void {
    if (this.isFormValid() && this.seller?.seller_id) {
      this.is_confirming_otp_running = true;

      this.sellers_service
        .confirmByAdmin(
          this.seller?.seller_id,
          this.confirm_otp_form_group.get(this.form_service.confirm_reason_label)?.value,
        )
        .subscribe({
          next: () => {
            this.dialog_ref.close({ success: true });
            this.is_confirming_otp_running = false;
          },
          error: error => {
            this.dialog_ref.close({ error });
            this.is_confirming_otp_running = false;
          },
        });
    }
  }
}
